// @ts-nocheck
import { type InferProps } from 'prop-types'

import { getPlaceholderImage } from 'shared/utils/imageUtils'
import { type CartControllerSellerGroupV2 } from 'types/api/cart'
import { ImageRowItem } from 'views/components/molecules/ImageRow/types'

export const imageItems = (
  group: CartControllerSellerGroupV2,
  mergeWithErx: boolean
): InferProps<typeof ImageRowItem>[] => {
  let items = group.groupEntries

  if (mergeWithErx) {
    items = items.concat(group.groupEntriesERx)
  }

  return items.reduce((response, entry) => {
    const groupEntryImageItems = entry.items.map(item => {
      return {
        id: item.isERx ? item.hashedToken : item.offerId,
        imageUrl:
          item.imageUrl || getPlaceholderImage(!!item.isERx || !!item.isRx),
        name: item.productName,
      }
    })

    return [...response, ...groupEntryImageItems]
  }, [])
}
